import { render } from "./TestFinishTips.vue?vue&type=template&id=c9d800f0&scoped=true"
import script from "./TestFinishTips.vue?vue&type=script&lang=js"
export * from "./TestFinishTips.vue?vue&type=script&lang=js"

import "./TestFinishTips.vue?vue&type=style&index=0&id=c9d800f0&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9d800f0"]])

export default __exports__